import { IconButton, ITask, Actions, styled, WorkerDirectoryTabs, Manager } from "@twilio/flex-ui";
import { useState, useEffect } from "react";
import  uhaulStore  from "../../../../../CustomRedux/UhaulStore"; 
import { TransferActionPayload } from "../../types/ActionPayloads";

const IconContainer = styled.div`
  margin: auto;
  padding-right: 0.8em;
`;
interface TransferButtonProps {
  task: ITask;
}

const TransferButton = ({ task }: TransferButtonProps) => {
  /*
   * All we are doing here is making sure we disable the transfer button after it is clicked for a cold transfer
   * There is additional complexity as we only want to disable it for the task they click transfer on
   */
  const [disableTransferButtonForTask, setDisableTransferButtonForTask] = useState(false);
  const [taskSidsTransfered, setTaskSidsTransfered] = useState<string[]>([]);

  // only listen for transfer task events when mounted and make sure we clean up the listener
  useEffect(() => {
    // if there is a transfer task event for this chat disable the transfer button if it was a cold transfer
    const handleTransferInitiated = (payload: TransferActionPayload) => {
      if (payload.options?.mode === "COLD") {
        setTaskSidsTransfered([...taskSidsTransfered, task.sid]);
      }
    };

    Actions.addListener("beforeTransferTask", handleTransferInitiated);
    return () => {
      Actions.removeListener("beforeTransferTask", handleTransferInitiated);
    };
  }, [taskSidsTransfered, task.sid]);

  // if the selected task changes or we update the list of transferred tasks check if should disable buttons
  useEffect(() => {
    setDisableTransferButtonForTask(taskSidsTransfered.includes(task.sid));
  }, [task.sid, taskSidsTransfered]);

  const onShowDirectory = () => {
/* 
 * remove current task's queue from the list of transferable queues in directory. this is to prevent a chat from redundantly being transfered back to same queue
 * also prevent internal queues from being visible 
 */
    const workerAttributes = Manager.getInstance().workerClient?.attributes;
    const transferQueueExclusionList = uhaulStore.getState().UhaulReducer.config.features.conversationTransfer.queueFilter;
    if (workerAttributes?.show_hidden_queues_in_transfer_list !== "true") {
      WorkerDirectoryTabs.defaultProps.queueFilter = (queue) => !transferQueueExclusionList.includes(queue.queueName) && queue.queueSid !== task.queueSid
    }

    Actions.invokeAction("ShowDirectory");
  };

  return (
    <IconContainer>
      <IconButton
        icon="TransferLarge"
        key="worker-directory-open"
        disabled={disableTransferButtonForTask}
        onClick={onShowDirectory}
        variant="secondary"
        title="Transfer Chat"
      />
    </IconContainer>
  );
};

export default TransferButton;
